import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserRegistrationService } from '../user-registration.service';
import { UserLoginService } from '../user-login.service';
import { LoggedInCallback } from '../cognito.service';

@Component({
    selector: 'app-logout',
    template: ''
})
export class LogoutComponent implements LoggedInCallback {

    constructor(public router: Router,
        public userService: UserLoginService) {
        this.userService.isAuthenticated(this);
    }

    isLoggedIn(message: string, isLoggedIn: boolean) {
        if (isLoggedIn) {
            this.userService.logoutAsync()
                .then(() => {
                    this.router.navigate(['/'], { queryParams: {} });
                });
        }
        this.router.navigate(['/'], { queryParams: {} });
    }
}

// @Component({
//     selector: 'awscognito-angular2-app',
//     templateUrl: './confirmRegistration.html'
// })
// export class RegistrationConfirmationComponent implements OnInit, OnDestroy {
//     confirmationCode: string;
//     email: string;
//     errorMessage: string;
//     private sub: any;

//     constructor(public regService: UserRegistrationService, public router: Router, public route: ActivatedRoute) {
//     }

//     ngOnInit() {
//         this.sub = this.route.params.subscribe({next: params => {
//             this.email = params['username'];

//         });

//         this.errorMessage = null;
//     }

//     ngOnDestroy() {
//         this.sub.unsubscribe();
//     }

//     onConfirmRegistration() {
//         this.errorMessage = null;
//         this.regService.confirmRegistration(this.email, this.confirmationCode, this);
//     }

//     cognitoCallback(message: string, result: any) {
//         if (message != null) { //error
//             this.errorMessage = message;
//             console.log('message: ' + this.errorMessage);
//         } else { //success
//             //move to the next step
//             console.log('Moving to securehome');
//             // this.configs.curUser = result.user;
//             this.router.navigate(['/securehome']);
//         }
//     }
// }




